import { render, staticRenderFns } from "./FeaturedPeopleListing.vue?vue&type=template&id=4e7cc72a&scoped=true"
import script from "./FeaturedPeopleListing.vue?vue&type=script&lang=js"
export * from "./FeaturedPeopleListing.vue?vue&type=script&lang=js"
import style0 from "./FeaturedPeopleListing.vue?vue&type=style&index=0&id=4e7cc72a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7cc72a",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/FeaturedPeopleListing.vue
// module id = 208
// module chunks = 0